import axios from 'axios';
const API_BASE = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';
function authHeader() {
  const auth = JSON.parse(localStorage.getItem('zocs_auth') || '{}');
  return { Authorization: `Bearer ${auth.token}` };
}

export async function retagUpload(file) {
  const fd = new FormData();
  fd.append('file', file);
  const res = await axios.post(`${API_BASE}/pricing/retag-upload`, fd, { headers: authHeader() });
  return res.data;
}

export async function getRetagItems(search = '') {
  const res = await axios.get(`${API_BASE}/pricing/retag-items`, {
    headers: authHeader(), params: search ? { search } : {},
  });
  return res.data;
}

export async function retagClear(itemId, binId) {
  const res = await axios.post(`${API_BASE}/pricing/retag-clear`,
    { item_id: itemId, bin_id: binId }, { headers: authHeader() });
  return res.data;
}

// ── Sale (saver_price) management ──────────────────────────────────────────
export async function saleAdd({ zoddle_barcode, sale_pct, sale_price }) {
  const res = await axios.post(`${API_BASE}/pricing/sale-add`,
    { zoddle_barcode, sale_pct, sale_price }, { headers: authHeader() });
  return res.data;
}

export async function saleRemove(zoddle_barcode) {
  const res = await axios.post(`${API_BASE}/pricing/sale-remove`,
    { zoddle_barcode }, { headers: authHeader() });
  return res.data;
}

export async function saleAddCsv(file) {
  const fd = new FormData(); fd.append('file', file);
  const res = await axios.post(`${API_BASE}/pricing/sale-add-csv`, fd, { headers: authHeader() });
  return res.data;
}

export async function saleRemoveCsv(file) {
  const fd = new FormData(); fd.append('file', file);
  const res = await axios.post(`${API_BASE}/pricing/sale-remove-csv`, fd, { headers: authHeader() });
  return res.data;
}
